import { render, staticRenderFns } from "./DrawingPictureface.vue?vue&type=template&id=29fb6dc6&scoped=true"
import script from "./DrawingPictureface.vue?vue&type=script&lang=js"
export * from "./DrawingPictureface.vue?vue&type=script&lang=js"
import style0 from "./DrawingPictureface.vue?vue&type=style&index=0&id=29fb6dc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29fb6dc6",
  null
  
)

export default component.exports